import React from "react";


const Textarea = () =>
{
    return(
        <>
        <textarea cols={10} rows={10}test></textarea>
        </>
    )
}

export default Textarea;